import {
  FacetedFilter,
  type FacetedFilterValue,
} from 'components/FacetedFilter/FacetedFilter';
import type { FC } from 'react';
import { useAttributes } from './useAttributes';

interface Props {
  value: FacetedFilterValue;
  onChange: (value: FacetedFilterValue) => void;
  globalAttributes: boolean;
}

export const DeviceAttributesFilter: FC<Props> = (props) => {
  const attributesHook = useAttributes({
    globalAttributes: props.globalAttributes,
  });

  return (
    <FacetedFilter
      loadAttributes={attributesHook.loadAttributes}
      makeLoadAttributeValues={attributesHook.makeLoadAttributeValues}
      value={props.value}
      onChange={props.onChange}
    />
  );
};
